import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'layouts/Layout';
import OrderList from './OrderList';

const OrderListLayout = ({ match }) => (
  <div>
    <Layout component={OrderList} match={match} />
  </div>
);
OrderListLayout.propTypes = {
  match: PropTypes.object,
};
export default OrderListLayout;
